import { render } from "./Footer.vue?vue&type=template&id=855b69a4&scoped=true"
import script from "./Footer.vue?vue&type=script&lang=js"
export * from "./Footer.vue?vue&type=script&lang=js"

import "@/styles/footer.css?vue&type=style&index=0&id=855b69a4&scoped=true&lang=css&external"
import "@/styles/common.css?vue&type=style&index=1&id=855b69a4&scoped=true&lang=css&external"

import exportComponent from "../../../../../../../../../../Desktop/중요/tcd-userpage-new/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-855b69a4"]])

export default __exports__